import type { SvgProps } from "../types";

export const LocationSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 400 400" fill="none">
      <title>Location</title>
      <path
        d="M205.735 290.665C155.409 242.963 94.9593 90.7124 198.78 64.9814C256.847 50.5932 289.256 117.652 275.878 166.285C264.567 207.397 234.224 242.805 215.301 280.323"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M189.108 132.102C246.901 97.3222 240.303 180.36 200.747 170.01C189.108 166.965 186.672 160.822 186.672 150.044"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M154.93 274.873C6.29812 328.742 232.117 357.483 281.256 319.162C318.054 290.46 277.824 274.873 249.19 274.873"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
